import React from 'react';
import KpiDevToDonePanel from './KpiDevToDonePanel';
import azureDevOpsService from './services/azureDevOpsService';

export default function KpiDemandesClientDevToDoneTime() {
  return (
    <KpiDevToDonePanel
      title="Temps moyen Dev → Done (Demandes Client)"
      subtitle="Demandes Client · La Fabrique · de l'état 2-Dev à 6-Done"
      fetchFn={(start, end, sample) =>
        azureDevOpsService.getAverageDemandeClientDevToDoneTime(start, end, sample)
      }
    />
  );
}
